// client/src/hooks/useBoardPresentation.js
// Shared by the dashboard board card and the docked footer's board card.
import { useEffect, useState } from 'react';

const personName = (leg) => leg?.name || (leg?.ext ? `Ext ${leg.ext}` : '');

/** Seconds since `fromMs`, ticking every second; frozen at `toMs` once set. */
export function useElapsed(fromMs, toMs = null) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!fromMs || toMs) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [fromMs, toMs]);
  return fromMs ? Math.max(0, Math.floor(((toMs || now) - fromMs) / 1000)) : 0;
}

/** "With Amanda Brown" / "Ringing Robert Taylor, Amanda Brown +2". */
export function boardWhoLine(call) {
  const legs = call.legs || [];
  if (call.status === 'Missed') return 'Not answered';
  if (call.status === 'Ended') {
    const who = call.answeredByName || (call.answeredBy ? `Ext ${call.answeredBy}` : '');
    return who ? `Answered by ${who}` : '';
  }
  if (call.status !== 'Ringing') {
    const on = legs.find((l) => l.ext === call.answeredBy) || legs.find((l) => l.status !== 'Ringing');
    const who = call.answeredByName || personName(on);
    return who ? `With ${who}` : '';
  }
  const ringing = legs.filter((l) => l.status === 'Ringing').map(personName).filter(Boolean);
  if (!ringing.length) return '';
  const shown = ringing.slice(0, 2).join(', ');
  return `Ringing ${shown}${ringing.length > 2 ? ` +${ringing.length - 2}` : ''}`;
}

